module.exports = __webpack_public_path__ + "static/media/ep7.0257561d.jpg";